import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import TopBar from '../../../componentsv2/TopBar';
import Skeleton from '../../../componentsv2/Skeleton';

export default function CreatePasswordSkeleton() {
  return (
    <>
      <TopBar>
        <Box sx={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <Skeleton width="180px" height="23px" />
        </Box>
      </TopBar>
      <Grid xs={12} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh' }}>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: '1em',
            paddingTop: { xs: '4em', md: '0' },
            width: { xs: '80%', md: '30%' },
          }}
        >
          <Skeleton width="70%" height="40px" />
          <Skeleton width="90%" height="24px" />
          <Skeleton width="100%" height="56px" />
          <Skeleton width="100%" height="56px" />
          <Skeleton width="100%" height="48px" />
        </Box>
      </Grid>
    </>
  );
}
